ready(() => {

    // СВОРАЧИВАНИЕ И РАЗВОРАЧИВАНИЕ СПИСКА КАТАЛОГА
    const visualCatalogList = document.querySelector(".list-term-visual-catalog");
    if (visualCatalogList) {
        const expanded = visualCatalogList.querySelectorAll("li.expanded a");
        const visualCatalogLink = visualCatalogList.querySelectorAll("a");
        const visualCatalogImagePreviewImg = document.querySelector(".visual-term__scheme-preview img");
        visualCatalogLink.forEach(item => {
            item.addEventListener("mouseenter", e => {
                if (e.currentTarget.closest('li').getAttribute("data-content")) {
                    visualCatalogImagePreviewImg.src = e.currentTarget.closest('li').getAttribute("data-content");
                } else {
                    visualCatalogImagePreviewImg.src = "";
                }
            });
        });
        expanded.forEach(item => {
            if (item.closest('li').classList.contains('expanded')) {
                item.addEventListener("click", e => {
                    e.preventDefault();
                    e.currentTarget.closest('li').classList.toggle("active-trail");
                });
            } else {
                item.addEventListener("click", e => {
                    e.currentTarget.closest('li').classList.toggle("active-trail");
                });
            }
        });
    }

    // СХЕМА
    /*
    const scheme = document.querySelector('.visual-term__scheme');
    if (scheme) {
        const targetImage = document.querySelector('#Image');
        if (targetImage) {
            jQuery("#Image").draggable({
                scroll: false,
            });
            const visualCatalogControl = document.querySelector('.image-control');
            if (visualCatalogControl) {
                const zoomUp = visualCatalogControl.querySelector('.form-control-up');
                const zoomDown = visualCatalogControl.querySelector('.form-control-down');
                const inputText = visualCatalogControl.querySelector('.form-text');
                const baseWidht = targetImage.getAttribute("data-width-100");
                const baseHeight = targetImage.getAttribute("data-height-100");
                inputText.value = 100;
                zoomUp.addEventListener("click",e => {
                    if (inputText.value < 500) {
                        inputText.value = parseInt(inputText.value) + 20;
                        targetImage.setAttribute("width", parseInt(baseWidht * inputText.value / 100));
                        targetImage.setAttribute("height", parseInt(baseHeight * inputText.value / 100));
                        targetImage.style.width = `${parseInt(baseWidht * inputText.value / 100)}px`;
                        targetImage.style.height = `${parseInt(baseHeight * inputText.value / 100)}px`;
                        targetImage.querySelectorAll('.nactiveLabel').forEach(label => {
                            let computedStyle = getComputedStyle(label);
                            label.style.width = `${parseInt(label.style.width) + 2}px`;
                            label.style.height = `${parseInt(label.style.height) + 2}px`;
                            label.style.fontSize = `${parseInt(computedStyle.fontSize) + 1}px`;
                            // label.style.width = `${Math.round(parseInt(label.style.width) + (parseInt(label.style.width) * 20 / 100))}px`;
                            // label.style.height = `${Math.round(parseInt(label.style.height) + (parseInt(label.style.height) * 20 / 100))}px`;
                            // label.style.fontSize = `${Math.round(parseInt(computedStyle.fontSize) + (parseInt(computedStyle.fontSize) * 20 / 100))}px`;
                        });
                    }
                });
                zoomDown.addEventListener("click",e => {
                    if (inputText.value > 20) {
                        inputText.value = parseInt(inputText.value) - 20;
                        targetImage.setAttribute("width", parseInt(baseWidht * inputText.value / 100));
                        targetImage.setAttribute("height", parseInt(baseHeight * inputText.value / 100));
                        targetImage.style.width = `${parseInt(baseWidht * inputText.value / 100)}px`;
                        targetImage.style.height = `${parseInt(baseHeight * inputText.value / 100)}px`;
                        targetImage.querySelectorAll('.nactiveLabel').forEach(label => {
                            let computedStyle = getComputedStyle(label);
                            label.style.width = `${parseInt(label.style.width) - 2}px`;
                            label.style.height = `${parseInt(label.style.height) - 2}px`;
                            label.style.fontSize = `${parseInt(computedStyle.fontSize) - 1}px`;
                            // label.style.width = `${Math.round(parseInt(label.style.width) - (parseInt(label.style.width) * 20 / 100))}px`;
                            // label.style.height = `${Math.round(parseInt(label.style.height) - (parseInt(label.style.height) * 20 / 100))}px`;
                            // label.style.fontSize = `${Math.round(parseInt(computedStyle.fontSize) - (parseInt(computedStyle.fontSize) * 20 / 100))}px`;
                        });
                    }
                });
            }

            jQuery('#Image').scrollingToElement({
                offsetTop: 150,
            });

            const labelPositionLink = document.querySelectorAll('.nactiveLabel a.labelFont');
            labelPositionLink.forEach(item => {
                item.addEventListener("click", e => {
                    e.preventDefault();
                    document.querySelectorAll('.teaser-node-visual-teaser1').forEach(item => {
                        item.classList.remove("is-active");
                    });
                    document.getElementById(item.getAttribute('href').substr(1)).scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    document.getElementById(item.getAttribute('href').substr(1)).classList.add("is-active");
                });
            });

        }
    }
    */

    // СВОРАЧИВАНИЕ И РАЗВОРАЧИВАНИЕ УЗЛА ДЕТАЛИ
    document.querySelectorAll('.teaser-node-visual-teaser1').forEach(item => {
        let field = item.querySelector('.field-find-price');
        if (field) {
            item.querySelector('.field-find-price a').addEventListener('click', e => {
                e.preventDefault();
                e.currentTarget.closest('.teaser').classList.toggle("is-open");
                e.currentTarget.closest('.teaser').classList.remove("is-active");
                if (e.currentTarget.closest('.teaser').classList.contains("is-open")) {
                    e.currentTarget.textContent = 'Свернуть';
                } else {
                    e.currentTarget.textContent = 'Узнать цену';
                }
            });
        }
    });

});






// ready(() => {
//
//     // СВОРАЧИВАНИЕ И РАЗВОРАЧИВАНИЕ СПИСКА КАТАЛОГА
//     const visualCatalogList = document.querySelector(".list-term-visual-catalog");
//     if (visualCatalogList) {
//         const expanded = visualCatalogList.querySelectorAll("li.expanded a");
//         const visualCatalogLink = visualCatalogList.querySelectorAll("a");
//         const visualCatalogImagePreviewImg = document.querySelector(".visual-image-preview img");
//         visualCatalogLink.forEach(item => {
//             item.addEventListener("mouseenter", e => {
//                 if (e.currentTarget.parentElement.getAttribute("data-content")) {
//                     visualCatalogImagePreviewImg.src = e.currentTarget.parentElement.getAttribute("data-content");
//                 } else {
//                     visualCatalogImagePreviewImg.src = "";
//                 }
//             });
//         });
//         expanded.forEach(item => {
//             if (item.parentNode.classList.contains('expanded')) {
//                 item.addEventListener("click", e => {
//                     e.preventDefault();
//                     e.currentTarget.parentElement.classList.toggle("active-trail");
//                 });
//             } else {
//                 item.addEventListener("click", e => {
//                     e.currentTarget.parentElement.classList.toggle("active-trail");
//                 });
//             }
//         });
//     }
//
//     // СХЕМА
//     const scheme = document.querySelector('.visual-term__scheme');
//     if (scheme) {
//         const targetImage = document.querySelector('#Image');
//         if (targetImage) {
//             jQuery("#Image").draggable({
//                 scroll: false,
//             });
//             const visualCatalogControl = document.querySelector('.image-control');
//             if (visualCatalogControl) {
//                 const zoomUp = visualCatalogControl.querySelector('.form-control-up');
//                 const zoomDown = visualCatalogControl.querySelector('.form-control-down');
//                 const inputText = visualCatalogControl.querySelector('.form-text');
//                 const baseWidht = targetImage.getAttribute("data-width-100");
//                 const baseHeight = targetImage.getAttribute("data-height-100");
//                 inputText.value = 100;
//                 zoomUp.addEventListener("click",e => {
//                     if (inputText.value < 500) {
//                         inputText.value = parseInt(inputText.value) + 20;
//                         targetImage.setAttribute("width", parseInt(baseWidht * inputText.value / 100));
//                         targetImage.setAttribute("height", parseInt(baseHeight * inputText.value / 100));
//                         targetImage.style.width = `${parseInt(baseWidht * inputText.value / 100)}px`;
//                         targetImage.style.height = `${parseInt(baseHeight * inputText.value / 100)}px`;
//                     }
//                 });
//                 zoomDown.addEventListener("click",e => {
//                     if (inputText.value > 20) {
//                         inputText.value = parseInt(inputText.value) - 20;
//                         targetImage.setAttribute("width", parseInt(baseWidht * inputText.value / 100));
//                         targetImage.setAttribute("height", parseInt(baseHeight * inputText.value / 100));
//                         targetImage.style.width = `${parseInt(baseWidht * inputText.value / 100)}px`;
//                         targetImage.style.height = `${parseInt(baseHeight * inputText.value / 100)}px`;
//                     }
//                 });
//             }
//
//             const labelPositionLink = document.querySelectorAll('.nactiveLabel a.labelFont');
//             labelPositionLink.forEach(item => {
//                 item.addEventListener("click", e => {
//                     e.preventDefault();
//                     document.querySelectorAll('.teaser-node-visual-teaser1').forEach(item => {
//                         item.classList.remove("is-active");
//                     });
//                     document.getElementById(item.getAttribute('href').substr(1)).scrollIntoView({
//                         behavior: 'smooth',
//                         block: 'start'
//                     });
//                     document.getElementById(item.getAttribute('href').substr(1)).classList.add("is-active");
//                 });
//             });
//
//         }
//     }
//
//     // СВОРАЧИВАНИЕ И РАЗВОРАЧИВАНИЕ УЗЛА ДЕТАЛИ
//     document.querySelectorAll('.teaser-node-visual-teaser1').forEach(item => {
//         let field = item.querySelector('.field-find-price');
//         if (field) {
//             item.querySelector('.field-find-price a').addEventListener('click', e => {
//                 e.preventDefault();
//                 e.currentTarget.closest('.teaser').classList.toggle("is-open");
//                 e.currentTarget.closest('.teaser').classList.remove("is-active");
//                 if (e.currentTarget.closest('.teaser').classList.contains("is-open")) {
//                     e.currentTarget.textContent = 'Свернуть';
//                 } else {
//                     e.currentTarget.textContent = 'Узнать цену';
//                 }
//             });
//         }
//     });
//
// });